<div id="managePopUp" class="new-modal-header" *ngIf="showLineIdentifierPopup">

  <div class="modal-header">
    <div class="modal-title">{{authoringContentData?.modalHeading}}</div>
    <button tabindex="0" type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body scroll-body" *ngIf="!isUdfAhub2Enabled; else udfAhub2">
    <div *ngIf="isSingleLine; else multiline">

      <div class="row m-0 bdrTop" *ngFor="let data of lineIdentifierLines[0]?.configModel;  let i = index">
          <div class="col-6 addGroup-label" *ngIf="data?.key !== 'udf6' || lineIdentifierLines[0]?.containsDHRatePlan">
            <label>{{data?.configLabel}}</label>
            <p>{{data?.configDesc}}</p>
          </div>
          <div class="col-6 p-0 auto-placeholder" *ngIf="data?.key !== 'udf6'">
            <input tabindex="0" type="text" class="addGroup-input w-100 text-right" maxlength="80" (keypress)="omit_special_char($event)" placeholder="Enter text here" [(ngModel)]="data.configValue"
              (ngModelChange)="onChangeInput(lineIdentifierLines[0])">
          </div>
          <div class="col-6 p-0 auto-placeholder" *ngIf="enableDHudf && data?.key === 'udf6' && lineIdentifierLines[0]?.containsDHRatePlan && lineIdentifierLines[0]?.productType === 'G'">
            <label tabindex="0" class="addGroup-input w-100 text-right disabled-udf" disabled="true">{{data.configValue}}</label>
            <span class="addGroup-input w-100 text-right disabled-text">{{authoringContentData?.subscriptionIdNoChangeText}}</span>
          </div>
          <div class="col-6 p-0 auto-placeholder" *ngIf="isEndUser && enableDHudf && data?.key === 'udf6' && lineIdentifierLines[0]?.containsDHRatePlan && lineIdentifierLines[0]?.productType !== 'G'">
            <label tabindex="0" class="addGroup-input w-100 text-right disabled-udf" disabled="true">{{data.configValue}}</label>
            <span class="addGroup-input w-100 text-right disabled-text">{{authoringContentData?.subscriptionIdHelpText}}</span>
          </div>
          <div class="col-6 p-0 auto-placeholder" *ngIf="!isEndUser && enableDHudf && data?.key === 'udf6' && lineIdentifierLines[0]?.containsDHRatePlan && lineIdentifierLines[0]?.productType !== 'G'">
            <mat-form-field class="w-100" [floatLabel]="'never'" id="singleFlow">
              <input matInput readonly placeholder="{{data?.configValue || authoringContentData?.subscriptionPlaceHolder}}"/>
              <mat-select [panelClass]='{"line-identifier-panel":true}'
                (openedChange)="onClickCloseIcon()" [(value)]="data.configValue"
                [(ngModel)]="data.configValue" (selectionChange)="onChangeInput(lineIdentifierLines[0])" class="udf-text-right">

                <mat-option class="option-padding" [disabled]="!(data.configValue)"
                  [ngClass]="{'txtColor':data.configValue}" (click)="onClear(lineIdentifierLines[0])">
                  {{authoringContentData?.clearFilterTxt}}</mat-option>
                <mat-divider></mat-divider>
                <div *ngIf="!isSearchVisible" class="option-padding">
                  <em class="fa fa-icon-size fa-search search-icon pull-right" (click)="onClickSearchIcon()"></em>
                  <span type="text">{{data?.configLabel}}</span>
                </div>
                <div *ngIf="isSearchVisible" class="option-padding">
                  <em class="fa fa-icon-size fa-search search-icon pull-left"></em>
                  <em class="fa fa-icon-size fa-times close-icon pull-right" (click)="onClickCloseIcon()"></em>
                  <input tabindex="0" type="text" class="search-box" [(ngModel)]="searchUdfText" autofocus autocomplete="off">
                </div>

                <mat-option
                class="udf-mat-option" *ngFor="let manageLineUdf of udf6FilterData |searchPipe : searchUdfText"
                  [ngbTooltip]="manageLineUdf.length>40? manageLineUdf : ''" value="{{manageLineUdf}}">{{manageLineUdf |
                  udfFormat:maxLengthOfUdf}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      </div>
      <hr *ngIf="enableCupNoRegrets" id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
    </div>
    <ng-template #multiline>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 tmo-numberOfLines">
          <span class="line-selected">
            {{lineIdentifierLines?.length}} {{authoringContentData?.linesSelectedTxt}}
          </span>
        </div>
      </div>

      <mat-accordion *ngFor="let line of lineIdentifierLines;let i = index">
        <mat-expansion-panel [expanded]="line.expandFlagValue" (closed)="expansionPanelClosed(line)"
          (opened)="expansionPanelOpened(line)">
          <mat-expansion-panel-header class="specific-class" >
            <mat-panel-title class="accordion-txt">
              {{line?.msisdn | phone}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="small-normal-black">
            <div class="row m-0" *ngFor="let data of line.configModel;  let i = index">

              <div class="col-6 p-0 mb-3" *ngIf="data?.key !== 'udf6'">
                <input tabindex="0" type="text" class="addGroup-input bdrBtm w-100" maxlength="80"  placeholder="{{data.configLabel}}" (keypress)="omit_special_char($event)" [(ngModel)]="data.configValue" (ngModelChange)="onChangeInput(line)">
              </div>
              <div class="col-6 p-0 mb-3" *ngIf="enableDHudf && data?.key === 'udf6' && line?.containsDHRatePlan && line?.productType === 'G'">
                <label tabindex="0" class="addGroup-input w-100 disabled-udf" disabled="true">{{data.configValue}}</label>
                <span class="addGroup-input w-100 disabled-text">{{authoringContentData?.subscriptionIdNoChangeText}}</span>
              </div>
              <div class="col-6 p-0 mb-3" *ngIf="enableDHudf && data?.key === 'udf6' && line?.containsDHRatePlan && line?.productType !== 'G'">
                <mat-form-field class="w-100" [floatLabel]="'never'">
                  <input matInput readonly placeholder="{{data?.configValue || authoringContentData?.subscriptionPlaceHolder}}"/>
                  <mat-select [panelClass]='{"line-identifier-panel":true}'
                              (openedChange)="onClickCloseIcon()" [(value)]="data.configValue"
                              [(ngModel)]="data.configValue" (selectionChange)="onChangeInput(line)">

                    <mat-option class="udf-mat-option-multiline" [disabled]="!(data.configValue)"
                                [ngClass]="{'txtColor':data.configValue}" (click)="onClear(line)">
                      {{authoringContentData?.clearFilterTxt}}</mat-option>
                    <mat-divider></mat-divider>
                    <div *ngIf="!isSearchVisible" class="search-div-multiline">
                      <em class="fa fa-icon-size fa-search search-icon pull-right" (click)="onClickSearchIcon()"></em>
                      <span type="text">{{data?.configLabel}}</span>
                    </div>
                    <div *ngIf="isSearchVisible" class="search-div-multiline">
                      <em class="fa fa-icon-size fa-search search-icon pull-left"></em>
                      <em class="fa fa-icon-size fa-times close-icon pull-right" (click)="onClickCloseIcon()"></em>
                      <input tabindex="0" type="text" class="search-box" [(ngModel)]="searchUdfText" autofocus autocomplete="off">
                    </div>

                    <mat-option
                      class="udf-mat-option-multiline" *ngFor="let manageLineUdf of udf6FilterData |searchPipe : searchUdfText"
                      [ngbTooltip]="manageLineUdf.length>15? manageLineUdf : ''" value="{{manageLineUdf}}">{{manageLineUdf |
                      udfFormat:maxLengthOfUdf}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>

            <div class="row align-items-center h-100 mt-4">
              <div class="col-12 col-md-4 mb-2">
                <button tabindex="0" type="button" class="col-12 primary_btn" [disabled]="!line.successValidator" (click)="onClickNext(line)" >{{authoringContentData?.nextCTA}}</button>
              </div>
              <div class="col-12 col-md-4 mb-2">
                <a tabindex="0" href="javascript:void(0)" (click)="removeNumber(line)" class="small-pink" >{{authoringContentData?.removeNumber}}</a>
              </div>


            </div>
          </div>
        </mat-expansion-panel>
        <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
      </mat-accordion>

    </ng-template>
    <div *ngIf="enableCupNoRegrets"><strong>{{authoringContentData?.advisementsText}}</strong></div>
    <div class="mt-4 text-color" *ngIf="enableCupNoRegrets">{{authoringContentData?.advisementTextLineOne}}</div>
    <div class="mt-4 text-color" *ngIf="enableCupNoRegrets">{{authoringContentData?.advisementTextLineTwo}}</div>

  </div>

  <ng-template #udfAhub2>
    <div *ngIf="isSingleLine; else multilineAhub2" class="scroll-body udf-align">

      <div class="d-flex w-100 align-items-center justify-content-between">
        <div class="row">
          <div class="col-12">
            <span class="accordion-txt m-0">
              {{lineIdentifierLines[0]?.msisdn ? (lineIdentifierLines[0]?.msisdn | phone) : ''}}
            </span>
          </div>
        </div>
      </div>
      <div class="row m-0" *ngFor="let data of lineIdentifierLines[0]?.configModel;  let i = index">
          <div class="col-12 addGroup-label">
            <label>{{data?.configLabel}}</label>
            <p>{{data?.configDesc}}</p>
          </div>
          <div class="col-12 p-0 auto-placeholder" *ngIf="data?.configType === 'text'">
            <input tabindex="0" type="text" class="addGroup-input w-50 ahub2-input" maxlength="80" (keypress)="omit_special_char($event)" placeholder="Enter text here" [(ngModel)]="data.configValue"
              (ngModelChange)="onChangeInput(lineIdentifierLines[0])">
          </div>
          <div class="col-12 p-0 auto-placeholder" *ngIf="data?.configType === 'Picklist'">
            <mat-form-field class="w-50" [floatLabel]="'never'" id="singleFlow">
              <!-- <input matInput readonly placeholder="{{data?.configValue}}"/> -->
              <mat-select [panelClass]='{"line-identifier-panel":true}'
                (openedChange)="onClickCloseIcon()" [(value)]="data.configValue"
                [(ngModel)]="data.configValue" (selectionChange)="onChangeInput(lineIdentifierLines[0])"
                class="ahub2-input ahub2-select-dropdown">
            
                <mat-option
                class="udf-mat-option" *ngFor="let manageLineUdf of data.pickListValue |searchPipe : searchUdfText"
                  [ngbTooltip]="manageLineUdf.length>40? manageLineUdf : ''" value="{{manageLineUdf}}">{{manageLineUdf |
                  udfFormat:maxLengthOfUdf}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      </div>
    </div>
    <ng-template #multilineAhub2>
      <div class="scroll-body multi-padding">
        <div class="row">
        <div class="col-12 col-sm-6 col-md-6 tmo-numberOfLines">
          <span class="line-selected">
            {{lineIdentifierLines?.length}} {{authoringContentData?.linesSelectedTxt}}
          </span>
        </div>
        </div>

        <mat-accordion *ngFor="let line of lineIdentifierLines;let i = index">
        <mat-expansion-panel [expanded]="line.expandFlagValue" (closed)="expansionPanelClosed(line)"
          (opened)="expansionPanelOpened(line)">
          <mat-expansion-panel-header class="specific-class">
            <div class="d-flex w-100 align-items-center justify-content-between">
              <div class="row">
                <div class="col-12">
                  <mat-panel-title class="accordion-txt m-0">
                    {{line?.msisdn | phone}}
                  </mat-panel-title>
                </div>
                <div class="col-12">
                  <a tabindex="0" href="javascript:void(0)" (click)="removeNumber(line)" class="small-pink ml-3">
                    {{authoringContentData?.removeNumber}}
                  </a>
                </div>
              </div>
            </div>
          </mat-expansion-panel-header>

          <div class="small-normal-black">
            <div class="row m-0" *ngFor="let data of line.configModel;  let i = index">
                <div class="col-12 addGroup-label">
                  <label>{{data?.configLabel}}</label>
                  <p>{{data?.configDesc}}</p>
                </div>
                <div class="col-12 p-0 auto-placeholder" *ngIf="data?.configType === 'text'">
                  <input tabindex="0" type="text" class="addGroup-input w-50 ahub2-input" maxlength="80" (keypress)="omit_special_char($event)" placeholder="Enter text here" [(ngModel)]="data.configValue"
                    (ngModelChange)="onChangeInput(line)">
                </div>
                <div class="col-12 p-0 auto-placeholder" *ngIf="data?.configType === 'Picklist'">
                  <mat-form-field class="w-50" [floatLabel]="'never'" id="multiFlow">
                    <!-- <input matInput readonly placeholder="{{data?.configValue}}"/> -->
                    <mat-select [panelClass]='{"line-identifier-panel":true}'
                      (openedChange)="onClickCloseIcon()" [(value)]="data.configValue"
                      [(ngModel)]="data.configValue" (selectionChange)="onChangeInput(line)"
                      class="ahub2-input ahub2-select-dropdown">
                  
                      <mat-option
                      class="udf-mat-option" *ngFor="let manageLineUdf of data.pickListValue |searchPipe : searchUdfText"
                        [ngbTooltip]="manageLineUdf.length>40? manageLineUdf : ''" value="{{manageLineUdf}}">{{manageLineUdf |
                        udfFormat:maxLengthOfUdf}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
            </div>


          </div>
        </mat-expansion-panel>
        <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
        </mat-accordion>
      </div>
    </ng-template>
  </ng-template>

  <div class="modal-footer flex-sm-row m-t-50">
    <button tabindex="0" *ngIf="isSingleLine" type="button" class="primary_btn m-b-10" (click)="updateLineIdentifier()" [disabled]="!submitEnabled || issubmitReadOnly">
      {{authoringContentData?.submitChangesCTA}}
    </button>
    <button tabindex="0" *ngIf="!isSingleLine" type="button" class="primary_btn m-b-10" (click)="updateLineIdentifierBulk()" [disabled]="!submitEnabled || issubmitReadOnly">
      {{authoringContentData?.submitChangesCTA}}
    </button>
    <button *ngIf="isUdfAhub2Enabled" tabindex="0" type="button" class="secondary_btn m-b-10" (click)="closeModal()">
      Cancel
    </button>
  </div>

</div>



<div id="managePopUp" *ngIf="showTechnicalIssuePopup">

  <div class="modal-header justify-content-start">
    <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-15 errorIcon" alt="Technical difficulties. Please try again later.">
    <h4 class="modal-title mt-0" id="modal-basic-title">{{errHeader ? errHeader : authoringContentData?.errorModalHeading}}</h4>
    <button tabindex="0" type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row m-0">
        <p class='errorMsg'>{{errBody ? errBody : authoringContentData?.errorModalTxt}}</p>
    </div>
  </div>

</div>
